import { useFilterModulesStore } from 'components/filter/filters-next/filterModules';
import { ServerKey } from 'components/filter/types';

interface ReadableStrategyProps {
    strategy: ServerKey;
}
const ReadableStrategy = ({ strategy }: ReadableStrategyProps) => {
    const filterModules = useFilterModulesStore(state => state.modules);
    const Readable = filterModules[strategy].Readable;

    return <Readable />;
};

export { ReadableStrategy };
